import React from 'react';
import { Grid, TextField } from '@mui/material';
import FormSection from './FormSection';

const InvoiceInfoSection = ({ formData, handleInputChange }) => {
  return (
    <FormSection title="Informations de la facture">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Numéro de facture"
            name="invoice_number"
            value={formData?.invoice_number || ''}
            onChange={handleInputChange}
            fullWidth
            required
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Bon de commande"
            name="purchase_order_number"
            value={formData?.purchase_order_number || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Numéros de référence"
            name="reference_numbers"
            value={formData?.reference_numbers || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Date de facture"
            name="invoice_date"
            value={formData?.invoice_date || ''}
            onChange={handleInputChange}
            fullWidth
            required
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Date d'échéance"
            name="due_date"
            value={formData?.due_date || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Date de paiement"
            name="payment_date"
            value={formData?.payment_date || ''}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default InvoiceInfoSection;